import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [params] = useSearchParams();
  const session_id = params.get("session_id") || undefined;
  const [f, setF] = useState({
    email: params.get("email") || "",
    password: "",
    name: "",
    phone: "",
    birthday: "",
  });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/customer/register", { ...f, session_id });
      login(data.token, data.customer);
      toast.success("Account created. Welcome to Preshh.");
      nav("/account");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Registration failed.");
    } finally { setBusy(false); }
  };
  return (
    <div className="text-white max-w-md mx-auto px-6 py-20">
      <p className="uppercase text-xs tracking-[0.3em] text-[#00B5D8] mb-3">Create your Preshh account</p>
      <h1 className="font-display text-4xl md:text-5xl">Join the club.</h1>
      <p className="mt-3 text-white/60 text-sm">Track orders. Own your products. Unlock a 15% birthday discount on accessories.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Input data-testid="reg-name" placeholder="Full name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="bg-white/5 border-white/10" />
        <Input data-testid="reg-email" type="email" placeholder="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="bg-white/5 border-white/10" />
        <Input data-testid="reg-password" type="password" placeholder="Password (min 8 chars)" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="bg-white/5 border-white/10" />
        <Input data-testid="reg-phone" placeholder="Phone (optional)" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="bg-white/5 border-white/10" />
        <div>
          <Input data-testid="reg-birthday" type="date" placeholder="Birthday" value={f.birthday} onChange={(e) => setF({ ...f, birthday: e.target.value })} className="bg-white/5 border-white/10 text-white" />
          <p className="text-xs text-white/50 mt-1">🎁 Used only for your birthday-month 15% accessory discount. Optional.</p>
        </div>
        <Button data-testid="reg-submit" type="submit" disabled={busy} className="w-full bg-[#00B5D8] hover:bg-[#009AB8] text-black font-bold rounded-full py-6">{busy ? "Creating…" : "Create account"}</Button>
      </form>
      <p className="mt-6 text-sm text-white/60">Already have an account? <Link to="/login" className="text-[#00B5D8] hover:underline">Sign in</Link></p>
    </div>
  );
}
